import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from 'src/app/analytics/google.analytics.service';
import { AuthService } from 'src/app/auth/auth.service';
import { ConnectionService } from 'src/app/shared-services/connection.service';
import { environment } from 'src/environments/environment';
declare var $: any;

@Component({
    selector: 'app-additional-resubmit',
    templateUrl: './additional-resubmit.component.html',
    styleUrls: ['./additional-resubmit.component.css']
})
export class AdditionalResubmitComponent implements OnInit {
    @Input() id = 0;
    public modalId = 'reSubmitModal' + this.id;
    public modalIdE = 'AdditionalResubmitCompleted' + this.id;

    public resubmitForm: FormGroup;
    public submitted: boolean = false;
    public errorTitle = '';
    public errorMessageA = '';
    public errorMessageB = '';
    public errorMessageC = '';
    public errorMessageBClass = '';
    public dialogClass = '';

    public vendorData: any = {
        numberOfElements: 0,
        totalElements: 0,
        records: []
    };

    public salespeopleData: any = [];

    public vNumberOfElements = 0;
    public vSliceNumber = 0;
    public vSliceSize = 8;
    public vTotalElements = 0;
    public vTotalPages = 0;
    public vSlices: number[] = [];

    public sNumberOfElements = 0;
    public sSliceNumber = 0;
    public sSliceSize = 8;
    public sTotalElements = 0;
    public sTotalPages = 0;
    public sSlices: number[] = [];

    public vendorSelected = { id: 0, name: '' };
    public salespersonSelected = { id: 0, name: '' };

    constructor(
        private connectionService: ConnectionService,
        private formBuilder: FormBuilder,
        private authService: AuthService,
        public googleAnalyticsService: GoogleAnalyticsService,
        public router: Router
    ) {
        this.resubmitForm = this.formBuilder.group({
            vendor: [''],
            salesperson: ['']
        });
    }

    ngOnInit() {
        this.modalId = 'reSubmitModal' + this.id;
        this.modalIdE = 'AdditionalResubmitCompleted' + this.id;
    }

    onClick() {
        this.resubmitForm.controls.vendor.setValue('');
        this.resubmitForm.controls.salesperson.setValue('');
        this.googleAnalyticsService.trackEvent('additional-options', 'open', 'replicate-opp-new-vendor');
        this.onVendorNameKeyUp(0, 8).then(
            () => $('#reSubmitModal' + this.id).modal()
        );
    }

    onSubmit() {
        this.submitted = true;
        if (this.resubmitForm.controls.vendor.errors || this.resubmitForm.controls.salesperson.errors) {
            return;
        }

        this.resubmitApplication().then(() => { }, () => { });
    }

    resubmitApplication() {
        const promise = new Promise((resolve, reject) => {
            if (this.salespersonSelected.id) {
                this.googleAnalyticsService.trackEvent('additional-options', 'submit', 'replicate-opp-new-vendor');
                const url = environment.gateway + 'application/' + this.id + '/newvendor/' + this.salespersonSelected.id;
                this.connectionService.postRequest(url, {}, 'application/json', 'sp_id=' + this.authService.getSalesPersonId()).subscribe(
                    (data: any) => {
                        this.router.navigateByUrl('/application/offers', { state: { applicationId: data.object.applicationId, generateOffers: true } });
                        $('#reSubmitModal' + this.id).modal('hide');
                        resolve(data);
                    },
                    (error: any) => {
                        this.errorTitle = 'Sorry, we found a problem';
                        this.errorMessageA = 'Unfortunately we are unable to process your request at this moment.';
                        this.errorMessageB = error.error.msg;
                        this.errorMessageC = 'Please contact customer service at 1-888-509-5592 for more information.';
                        this.errorMessageBClass = 'mB20';
                        this.dialogClass = 'w600';
                        $('#errorModalDialogAdditionalResubmitCompleted' + this.id).modal();
                        reject(error);
                    }
                );
            } else {
                this.errorTitle = 'Sorry, we found a problem';
                this.errorMessageA = 'Unfortunately we are unable to process your request at this moment.';
                this.errorMessageB = '';
                this.errorMessageC = 'Please contact customer service at 1-888-509-5592 for more information.';
                this.errorMessageBClass = 'mB20';
                this.dialogClass = 'w600';
                $('#errorModalDialogAdditionalResubmitCompleted' + this.id).modal();
                reject(null);
            }
        });
        return promise;
    }

    onVendorNameKeyUp(slice: number, elements: number) {
        this.resubmitForm.controls.salesperson.setValue('');
        this.vendorSelected = { id: 0, name: '' };
        this.salespersonSelected = { id: 0, name: '' };
        this.salespeopleData = [];

        this.sNumberOfElements = 0;
        this.sSliceNumber = 0;
        this.sSliceSize = 8;
        this.sTotalElements = 0;
        this.sTotalPages = 0;
        this.sSlices = [];

        const promise = new Promise((resolve, reject) => {
            this.getVendors(this.resubmitForm.controls.vendor.value, slice, elements).then(
                (vendorsData: any) => {
                    this.vendorSelected = { id: 0, name: '' };

                    this.vendorData = vendorsData.object;
                    this.vNumberOfElements = vendorsData.object && vendorsData.object.numberOfElements ? vendorsData.object.numberOfElements : 0;
                    this.vSliceNumber = vendorsData.object && vendorsData.object.sliceNumber ? vendorsData.object.sliceNumber : 0;
                    this.vSliceSize = vendorsData.object && vendorsData.object.sliceSize ? vendorsData.object.sliceSize : 0;
                    this.vTotalElements = vendorsData.object && vendorsData.object.totalElements ? vendorsData.object.totalElements : 0;
                    this.vTotalPages = vendorsData.object && vendorsData.object.totalPages ? vendorsData.object.totalPages : 0;
                    this.vSlices = Array.from(Array(this.vTotalPages), (x, index) => index + 1);
                    resolve(vendorsData);
                },
                (vendorsError: any) => {
                    this.vendorData = {
                        numberOfElements: 0,
                        totalElements: 0,
                        records: []
                    };
                    resolve(vendorsError);
                }
            );
        });

        return promise;
    }

    onSalespersonNameKeyUp(slice: number, elements: number) {
        this.salespersonSelected = { id: 0, name: '' };
        const promise = new Promise((resolve, reject) => {
            if (this.vendorSelected.id) {
                this.getSalesPeople(this.vendorSelected.id, this.resubmitForm.controls.salesperson.value, slice, elements).then(
                    (salespeopleData: any) => {
                        this.salespeopleData = salespeopleData.object.records;
                        this.sNumberOfElements = salespeopleData.object && salespeopleData.object.numberOfElements ? salespeopleData.object.numberOfElements : 0;
                        this.sSliceNumber = salespeopleData.object && salespeopleData.object.sliceNumber ? salespeopleData.object.sliceNumber : 0;
                        this.sSliceSize = salespeopleData.object && salespeopleData.object.sliceSize ? salespeopleData.object.sliceSize : 0;
                        this.sTotalElements = salespeopleData.object && salespeopleData.object.totalElements ? salespeopleData.object.totalElements : 0;
                        this.sTotalPages = salespeopleData.object && salespeopleData.object.totalPages ? salespeopleData.object.totalPages : 0;
                        this.sSlices = Array.from(Array(this.sTotalPages), (x, index) => index + 1);
                        resolve(salespeopleData);
                    },
                    (salespeopleError: any) => {
                        this.salespeopleData = [];
                        resolve(salespeopleError);
                    }
                );
            } else {
                this.resubmitForm.controls.salesperson.setValue('');
                this.salespeopleData = [];
                resolve(null);
            }
        });

        return promise;
    }

    onVendorClick(vendor: any) {
        this.vendorSelected = vendor;
        this.resubmitForm.controls.salesperson.setValue('');
        this.onSalespersonNameKeyUp(0, 8);
    }

    onSalespersonClick(salesperson: any) {
        this.salespersonSelected = salesperson;
    }

    getVendors(vendorName: string, page: number, pageSize: number) {
        const promise = new Promise((resolve, reject) => {
            this.connectionService.getRequest(
                environment.gateway + 'vendor/filtered/' + page + '/' + pageSize, 'application/json', 'name=' + vendorName
            ).subscribe(
                (data: any) => {
                    resolve(data);
                },
                (error: any) => {
                    reject(error);
                }
            );
        });
        return promise;
    }

    getSalesPeople(vendorId: number, salesPersonName: string, page: number, pageSize: number) {
        const promise = new Promise((resolve, reject) => {
            this.connectionService.getRequest(
                environment.gateway + 'salesperson/filtered/' + page + '/' + pageSize, 'application/json',
                'vendorId=' + vendorId + '&name=' + salesPersonName
            ).subscribe(
                (data: any) => {
                    resolve(data);
                },
                (error: any) => {
                    reject(error);
                }
            );
        });
        return promise;
    }

    onVBackClick() {
        if (this.vSliceNumber > 0) {
            this.onVendorNameKeyUp(this.vSliceNumber - 1, this.vSliceSize);
        }
    }

    onVSliceClick(slice: number) {
        this.onVendorNameKeyUp(slice, this.vSliceSize);
    }

    onVNextClick() {
        if (this.vSliceNumber < this.vTotalPages - 1) {
            this.onVendorNameKeyUp(this.vSliceNumber + 1, this.vSliceSize);
        }
    }

    onSBackClick() {
        if (this.sSliceNumber > 0) {
            this.onSalespersonNameKeyUp(this.sSliceNumber - 1, this.sSliceSize);
        }
    }

    onSSliceClick(slice: number) {
        this.onSalespersonNameKeyUp(slice, this.sSliceSize);
    }

    onSNextClick() {
        if (this.sSliceNumber < this.sTotalPages - 1) {
            this.onSalespersonNameKeyUp(this.sSliceNumber + 1, this.sSliceSize);
        }
    }

    get isSalesPersonDisabled() {
        return this.salespeopleData.length < 1;
    }
}
